<template>
	<div class="d-flex align-items-center justify-content-between w-100">
		<label
			id="hideinmobile"
			class="teams-label-font w-40"
			v-if="!fromSignupForm"
		>
			<span>{{ label }}</span>
			<span v-if="mandatory" class="asterik">&nbsp;*</span>
		</label>
		<!-- :class="
				$v.profile.inputData.$error || invalidPhone
					? 'inputData-error'
					: 'inputData-input'
			" -->
		<div
			:class="[
				showError || invalidPhone ? 'errorfields' : 'inputData-input',
				fromSignupForm && (showError || invalidPhone) ? 'su-input-error' : '',
			]"
			class="w-100 d-flex align-items-center phonenumber-input position-relative inputData-input pl-0"
		>
			<div
				class="phonenumberlabel floating-label"
				:class="{ 'su-inputs': fromSignupForm }"
			>
				<b-form-input
					class="w-100"
					:id="id"
					v-model="inputData"
					type="tel"
					:maxlength="maxPhoneLength"
					@keypress="
						(e) => {
							if (!/[0-9]/.test(e.key)) e.preventDefault();
						}
					"
					@focus="isFocused = true"
					@blur="isFocused = false"
					placeholder=" "
				></b-form-input>
				<label
					v-if="!fromSignupForm"
					id="hideinlaptop"
					:class="{ active: isFocused || inputData }"
				>
					{{ label }}
					<span v-if="mandatory" class="asterik">&nbsp;*</span>
				</label>
			</div>
			<div
				v-if="invalidPhone && !showError"
				class="candash-errortxt errortxt-pos-1"
			>
				Enter a valid phone number
			</div>
		</div>
	</div>
</template>

<script>
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
export default {
	props: {
		fromSignupForm: Boolean,
		disabled: Boolean,
		mandatory: Boolean,
		showError: Boolean,
		type: String,
		label: String,
		placeholder: String,
		id: String,
		type: String,
		code: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
	},
	watch: {
		vmodel(val) {
			this.inputData = val ? val.replace(/\s+/g, "") : "";
			// If iti is already initialised (async API prefill after mount),
			// strip the dial-code prefix and re-validate immediately.
			if (this._iti && this._inputEl) {
				this.stripAndValidate();
				this.$emit("phonevalidation", this.invalidPhone);
			}
		},
		code(val) {
			this.countryCode = val;
			console.log(val, "valllllllllllllllllllllllllll");
		},
	},
	computed: {
		maxPhoneLength() {
			return null;
		},
	},
	data() {
		return {
			isFocused: false,
			inputData: "",
			invalidPhone: false,
			countryCode: "+91",
			_iti: null,
			_inputEl: null,
			_utilsReady: false,
		};
	},
	created() {
		if (this.vmodel) {
			this.inputData = this.vmodel;
			this.$emit("select-value", this.inputData);
		}
		if (this.code) {
			this.countryCode = this.code;
			this.$emit("select-country-code", this.countryCode);
		}
	},
	mounted() {
		this.initializeTel();
	},
	methods: {
		stripPrefix(raw) {
			let value = raw ? raw.replace(/\s+/g, "") : "";
			const codeWithPlus = this.countryCode.startsWith("+")
				? this.countryCode
				: "+" + this.countryCode;
			const dialCodeNoPlus = codeWithPlus.replace("+", "");

			// Strip dial code prefix when the stored number includes it (any country)
			if (value && value.startsWith(codeWithPlus)) {
				value = value.substring(codeWithPlus.length).trim();
			} else if (value && value.startsWith(dialCodeNoPlus)) {
				value = value.substring(dialCodeNoPlus.length).trim();
			}
			return value;
		},
		stripAndValidate() {
			if (!this._iti || !this._inputEl) return;

			const value = this.stripPrefix(this.inputData);

			if (this.inputData !== value) {
				this.inputData = value;
			}
			// Sync raw input element value
			if (this._inputEl.value !== this.inputData) {
				this._inputEl.value = this.inputData;
			}

			if (!value) {
				this.invalidPhone = false;
			} else if (this._utilsReady) {
				// utils.js is loaded — isValidNumber() is reliable
				this.invalidPhone = !this._iti.isValidNumber();
			} else {
				// utils not yet loaded — skip validation, show no error
				this.invalidPhone = false;
			}
		},
		async initializeTel() {
			const input = document.getElementById(this.id);
			if (!input) return;

			const iti = intlTelInput(input, {
				utilsScript:
					"https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.3/js/utils.js",
				showSelectedDialCode: true,
				nationalMode: true,
			});

			this._iti = iti;
			this._inputEl = input;

			const dropdown = input.parentElement.querySelector(
				".iti__flag-container"
			);
			dropdown.addEventListener("click", () => {
				const searchField = dropdown.querySelector(
					".iti__dropdown-content .iti__search-input"
				);
				if (searchField) {
					searchField.value = "";
					searchField.dispatchEvent(new Event("input", { bubbles: true }));
				}
			});

			// Set the correct country flag from the stored countryCode
			const dial = this.countryCode.startsWith("+")
				? this.countryCode.split("+")[1]
				: this.countryCode;
			const countryData = iti.countries.find((c) => c.dialCode === dial);
			if (countryData) {
				iti.setCountry(countryData.iso2);
			}

			// Wait for utils.js to finish loading before any isValidNumber() call
			await iti.promise;
			this._utilsReady = true;

			// Now validate any prefilled number
			if (this.inputData) {
				this.stripAndValidate();
				this.$emit("phonevalidation", this.invalidPhone);
			}

			input.addEventListener("countrychange", () => {
				const code = "+" + iti.getSelectedCountryData().dialCode;
				if (code !== this.countryCode) {
					this.countryCode = code;
					this.stripAndValidate();
				}
				const value = (this.inputData || "").replace(/\s+/g, "");
				this.invalidPhone =
					value && this._utilsReady ? !iti.isValidNumber() : false;
				this.$emit("select-country-code", this.countryCode);
				this.$emit("select-value", this.inputData);
				this.$emit("phonevalidation", this.invalidPhone);
			});

			input.addEventListener("input", () => {
				this.stripAndValidate();
				this.$emit("select-country-code", this.countryCode);
				this.$emit("select-value", this.inputData);
				this.$emit("phonevalidation", this.invalidPhone);
			});
		},
	},
};
</script>

<style scoped>
.phoneinput.form-control {
	border-radius: 8px;
	font-family: "Montserrat", sans-serif;
	height: 38px;
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	color: var(--cv-darkgrey);
}

.phonenumber-input .su-inputs input[type="tel"] {
	width: 100%;
	padding: 16px 24px;
	font-size: var(--size-16);
	border-radius: 3px;
	box-sizing: border-box;
}

.phonenumber-input .su-inputs input {
	width: 100%;
	padding: 16px 24px;
	border: 1px solid #e2e8f0;
	border-radius: 32px;
	transition: border-color 0.3s ease;
}

.phonenumber-input .su-inputs .form-control {
	height: 48px !important;
	border-radius: 32px !important;
	border: 1px solid #e2e8f0 !important;
	background: #ffffff !important;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05) !important;
	color: #332d2d !important;
	font-size: var(--size-14) !important;
	font-weight: 500 !important;
}
</style>
<style>
.phonenumber-input
	.su-inputs
	.iti--show-selected-dial-code
	.iti__selected-flag {
	background: #fff !important;
	border-radius: 32px 0px 0px 32px;
}
.phonenumber-input .su-inputs .iti--inline-dropdown .iti__country-list {
	max-height: 125px !important;
}
.su-input-error {
	border-radius: 32px !important;
}
.phonenumber-input .su-inputs .form-control:focus {
	border: 1px solid #4a7eff !important;
	box-shadow: none;
}
/* When input has error, keep red border on focus — don't let blue override it */
.phonenumber-input.errorfields .su-inputs .form-control:focus,
.su-input-error .su-inputs .form-control:focus {
	border: 1px solid #dc3545 !important;
	box-shadow: none !important;
}
</style>
